import angular from "angular";

import template from "./instructor-course-attendance.html";
import InstructorCourseAttendanceController from "./instructor-course-attendance.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.instructor.dashboard.course.attendance", {
    url: "/attendance",
    template: template,
    controller: InstructorCourseAttendanceController,
    controllerAs: "vm",
    resolve: {
      course: getCourse,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.instructor,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

function getCourse($stateParams, CoursesModel) {
  return CoursesModel.show($stateParams.courseId).then((response) => {
    return response.course;
  });
}
getCourse.$inject = ["$stateParams", "CoursesModel"];

export default angular
  .module("instructor.dashboard.course.attendance", [])
  .config(config)
  .controller(
    "InstructorCourseAttendanceController",
    InstructorCourseAttendanceController,
  );
